import { useCallback, useEffect, useState } from 'react'

export type StatusMessage = {
    tone: 'success' | 'error'
    message: string
}

export const useStatusMessage = () => {
    const [status, setStatus] = useState<StatusMessage | null>(null)

    const showSuccess = useCallback((message: string) => {
        setStatus({
            tone: 'success',
            message,
        })
    }, [])

    const showError = useCallback((message: string) => {
        setStatus({
            tone: 'error',
            message,
        })
    }, [])

    const clearStatus = useCallback(() => {
        setStatus(null)
    }, [])

    const clearSuccess = useCallback(() => {
        setStatus((current) => (current?.tone === 'success' ? null : current))
    }, [])

    useEffect(() => {
        if (status?.tone !== 'success') {
            return
        }

        const timeout = window.setTimeout(() => {
            setStatus(null)
        }, 10000)

        return () => window.clearTimeout(timeout)
    }, [status])

    return {
        status,
        showSuccess,
        showError,
        clearStatus,
        clearSuccess,
    }
}
